import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'motors-vehicle-details-header-section',
    templateUrl: './motors-vehicle-details-header-section.component.html',
    styleUrls: ['./motors-vehicle-details-header-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MotorsVehicleDetailsHeaderSectionComponent {
    // TODO: get rid of this comment after implemented
    // ### How to implement opening/closing modal ###
    // assuming modal is implemented using tg-modal
    // and the modal is wrapped in a shared component
    // render the shared component in template file
    // and refer to the below files for implementation
    // libs\property-ui\src\lib\sections\property-default-sections\property-promote-section\property-promote-section.component.ts
    // libs\property-ui\src\lib\sections\property-default-sections\property-promote-section\property-promote-section.component.html
}
